/** East Africa Time — Africa/Nairobi (UTC+3), used across the whole QMS UI. */

export const EAT_TZ = 'Africa/Nairobi';

const EAT_LOCALE = 'en-KE';

/** Parse API datetimes; naive strings from the server are treated as EAT wall time. */
export function parseEat(iso) {
  if (!iso) return null;
  const s = String(iso);
  const hasOffset = /[Zz]$|[+-]\d{2}:\d{2}$/.test(s);
  const normalized = hasOffset ? s : `${s}+03:00`;
  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatEat(iso, options = {}) {
  const d = parseEat(iso);
  if (!d) return '—';
  return d.toLocaleString(EAT_LOCALE, { timeZone: EAT_TZ, ...options });
}

export function formatEatTime(iso, options = {}) {
  return formatEat(iso, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });
}

export function formatEatDate(iso, options = {}) {
  return formatEat(iso, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    ...options,
  });
}

export function nowEatString(options = {}) {
  return new Date().toLocaleString(EAT_LOCALE, { timeZone: EAT_TZ, ...options });
}

export function nowEatTimeString(options = {}) {
  return new Date().toLocaleTimeString(EAT_LOCALE, { timeZone: EAT_TZ, ...options });
}

export function nowEatDateString(options = {}) {
  return new Date().toLocaleDateString(EAT_LOCALE, { timeZone: EAT_TZ, ...options });
}

export function todayEatIso() {
  return new Date().toLocaleDateString('en-CA', { timeZone: EAT_TZ });
}
